export const CREATE_SYSTEM_MESSAGE = 'CREATE_SYSTEM_MESSAGE';
export const REMOVE_SYSTEM_MESSAGE = 'REMOVE_SYSTEM_MESSAGE';
